import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { PatronEditBooking } from "../../../types";
import { currentBookingAtom } from "../../stores";

const isGolfRoundRate = (
  rate: PatronEditBooking.RoundRate | null | undefined
): rate is PatronEditBooking.GolfRoundRate => {
  return (
    typeof rate === "object" &&
    rate !== null &&
    "dynamicOverridden" in rate &&
    "id" in rate
  );
};

const isGolfRound = (
  round: PatronEditBooking.Round
): round is PatronEditBooking.GolfRound => {
  return round.type === "Golf";
};

export const getDynamicLockedRoundIdsAtom = atomFamily((roundId: string) => {
  return atom((get) => {
    const booking = get(currentBookingAtom);
    if (!booking || booking.type !== "Golf" || booking.status !== "CONFIRMED") {
      return { hasDynamicLockedRound: false, isLockedDynamicRate: false };
    }

    const dynamicLockedRounds = booking.rounds
      .filter(isGolfRound)
      .filter((round: PatronEditBooking.GolfRound) => {
        return (
          isGolfRoundRate(round.roundRate) &&
          round.roundRate.dynamicOverridden &&
          round.serverId === round.localId &&
          round.serverId !== null
        );
      })
      .map((round: PatronEditBooking.GolfRound) => round.serverId);

    return {
      hasDynamicLockedRound: dynamicLockedRounds.length > 0,
      isLockedDynamicRate: dynamicLockedRounds.includes(roundId),
    };
  });
});
